export type LanguageCode = {
  languageCode: string;
  countryCode: string;
  name: string;
};

export const languageCodes: LanguageCode[] = [
  {
    languageCode: 'ar-SA',
    countryCode: 'SA',
    name: 'Arabic',
  },
  {
    languageCode: 'bg',
    countryCode: 'BG',
    name: 'Bulgarian',
  },
  {
    languageCode: 'zh-CN',
    countryCode: 'CN',
    name: 'Chinese',
  },
  {
    languageCode: 'hr',
    countryCode: 'HR',
    name: 'Croatian',
  },
  {
    languageCode: 'cs',
    countryCode: 'CZ',
    name: 'Czech',
  },
  {
    languageCode: 'da',
    countryCode: 'DK',
    name: 'Danish',
  },
  {
    languageCode: 'nl',
    countryCode: 'NL',
    name: 'Dutch',
  },
  {
    languageCode: 'en-GB',
    countryCode: 'GB',
    name: 'English',
  },
  {
    languageCode: 'en-US',
    countryCode: 'US',
    name: 'English (US)',
  },
  {
    languageCode: 'fa',
    countryCode: 'IR',
    name: 'Farsi',
  },
  {
    languageCode: 'fi',
    countryCode: 'FI',
    name: 'Finnish',
  },
  {
    languageCode: 'fr',
    countryCode: 'FR',
    name: 'French',
  },
  {
    languageCode: 'de',
    countryCode: 'DE',
    name: 'German',
  },
  {
    languageCode: 'el',
    countryCode: 'GR',
    name: 'Greek',
  },
  {
    languageCode: 'hi',
    countryCode: 'IN',
    name: 'Hindi',
  },
  {
    languageCode: 'hu',
    countryCode: 'HU',
    name: 'Hungarian',
  },
  {
    languageCode: 'it',
    countryCode: 'IT',
    name: 'Italian',
  },
  {
    languageCode: 'ja',
    countryCode: 'JP',
    name: 'Japanese',
  },
  {
    languageCode: 'ko',
    countryCode: 'ko',
    name: 'Korean',
  },
  {
    languageCode: 'lt',
    countryCode: 'LT',
    name: 'Lithuanian',
  },
  {
    languageCode: 'ms',
    countryCode: 'MY',
    name: 'Malay',
  },
  {
    languageCode: 'no',
    countryCode: 'NO',
    name: 'Norwegian',
  },
  {
    languageCode: 'pl',
    countryCode: 'PL',
    name: 'Polish',
  },
  {
    languageCode: 'pt-pt',
    countryCode: 'PT',
    name: 'Portugese',
  },
  {
    languageCode: 'pt-br',
    countryCode: 'BR',
    name: 'Brazilian Portugese',
  },
  {
    languageCode: 'ro',
    countryCode: 'RO',
    name: 'Romanian',
  },
  {
    languageCode: 'ru',
    countryCode: 'RU',
    name: 'Russian',
  },
  {
    languageCode: 'sb',
    countryCode: 'RS',
    name: 'Serbian',
  },
  {
    languageCode: 'sk',
    countryCode: 'SK',
    name: 'Slovakian',
  },
  {
    languageCode: 'es',
    countryCode: 'ES',
    name: 'Spanish',
  },
  {
    languageCode: 'sv',
    countryCode: 'SE',
    name: 'Swedish',
  },
  {
    languageCode: 'th',
    countryCode: 'TH',
    name: 'Thai',
  },
  {
    languageCode: 'tr',
    countryCode: 'TR',
    name: 'Turkish',
  },
  {
    languageCode: 'uk',
    countryCode: 'UA',
    name: 'Ukranian',
  },
];
